export const GET_EXEMPTIONS_BEGIN = 'GET_EXEMPTIONS_BEGIN'
export const GET_EXEMPTIONS_SUCCESS = 'GET_EXEMPTIONS_SUCCESS'
export const GET_EXEMPTIONS_ERROR = 'GET_EXEMPTIONS_ERROR'

export const DELETE_EXEMPTION_BEGIN = 'DELETE_EXEMPTION_BEGIN'
export const DELETE_EXEMPTION_SUCCESS = 'DELETE_EXEMPTION_SUCCESS'
export const DELETE_EXEMPTION_ERROR = 'DELETE_EXEMPTION_ERROR'

export const CREATE_EXEMPTION_BEGIN = 'CREATE_EXEMPTION_BEGIN'
export const CREATE_EXEMPTION_SUCCESS = 'CREATE_EXEMPTION_SUCCESS'
export const CREATE_EXEMPTION_ERROR = 'CREATE_EXEMPTION_ERROR'

export const UPDATE_EXEMPTION_BEGIN = 'UPDATE_EXEMPTION_BEGIN'
export const UPDATE_EXEMPTION_SUCCESS = 'UPDATE_EXEMPTION_SUCCESS'
export const UPDATE_EXEMPTION_ERROR = 'UPDATE_EXEMPTION_ERROR'

export const ADD_USER_EXEMPTION_BEGIN = 'ADD_USER_EXEMPTION_BEGIN'
export const ADD_USER_EXEMPTION_SUCCESS = 'ADD_USER_EXEMPTION_SUCCESS'
export const ADD_USER_EXEMPTION_ERROR = 'ADD_USER_EXEMPTION_ERROR'

export const DELETE_USER_EXEMPTION_BEGIN = 'DELETE_USER_EXEMPTION_BEGIN'
export const DELETE_USER_EXEMPTION_SUCCESS = 'DELETE_USER_EXEMPTION_SUCCESS'
export const DELETE_USER_EXEMPTION_ERROR = 'DELETE_USER_EXEMPTION_ERROR'

export const ADD_TASK_EXEMPTION_BEGIN = 'ADD_TASK_EXEMPTION_BEGIN'
export const ADD_TASK_EXEMPTION_SUCCESS = 'ADD_TASK_EXEMPTION_SUCCESS'
export const ADD_TASK_EXEMPTION_ERROR = 'ADD_TASK_EXEMPTION_ERROR'

export const DELETE_TASK_EXEMPTION_BEGIN = 'DELETE_TASK_EXEMPTION_BEGIN'
export const DELETE_TASK_EXEMPTION_SUCCESS = 'DELETE_TASK_EXEMPTION_SUCCESS'
export const DELETE_TASK_EXEMPTION_ERROR = 'DELETE_TASK_EXEMPTION_ERROR'

export const CLEAR_NEW_EXEMPTION_STATE = 'CLEAR_NEW_EXEMPTION_STATE'